import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import heroImg from '../../asstes/hero-image-cro.png';

export default function CroHero() {
    return (
        <section className="cro-hero">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} md={12}>
                        <div className="cro-badge">
                            <span className="badge-dot"></span>
                            AI-Powered CRO Solutions
                        </div>
                        <h1>
                            We Help eCommerce Brands{' '}
                            <span className="gradient-text">Increase Conversion Rates</span>{' '}
                            With AI‑Assisted CRO
                        </h1>
                        <p className="hero-sub">
                            Landing pages, A/B testing, UX optimization, and experimentation
                            systems — engineered to turn more visitors into paying customers.
                        </p>
                        <div className="cro-hero-btns">
                            <Link to="/book-audit" className="cro-btn-primary">
                                Book Free CRO Audit <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                            </Link>
                            <a href="#case-studies" className="cro-btn-outline">
                                View Case Studies
                            </a>
                        </div>
                    </Col>
                    <Col lg={6} md={12}>
                        <div className="cro-hero-visual">
                            <img src={heroImg} alt="CRO Analytics Dashboard with Heatmaps and Conversion Metrics" />
                            <div className="floating-stat stat-1">
                                <span className="stat-value">+34%</span>
                                <span className="stat-label">Conversion Rate</span>
                            </div>
                            <div className="floating-stat stat-2">
                                <span className="stat-value">−47%</span>
                                <span className="stat-label">Bounce Rate</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

